module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cb-body__wrap"
  }, [_c('div', {
    staticClass: "cb-body__content"
  }, [_c('div', {
    staticClass: "cb-section"
  }, [_vm._t("default"), _vm._v(" "), _c('account-summary', {
    attrs: {
      "account": _vm.account,
      "fields-to-show": _vm.fields
    }
  }), _vm._v(" "), _c('cb-notes', {
    attrs: {
      "custom-class": 'cb-section--md',
      "type": 'info',
      "message": _vm.t('account.note')
    }
  })], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8e05365c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/portal/PortalAccountComponent.vue
// module id = 603
// module chunks = 66